import { isMacOs } from './isMacOs';
const MAC_COPY_SHORTCUT = '⌘C';
const DEFAULT_COPY_SHORTCUT = 'Ctrl+C';

/**
 * Display label for the copy keyboard shortcut, matching the modifier the copy
 * handler actually listens for (Cmd on Mac, Ctrl everywhere else).
 *
 * Not translated: these are the key names printed on the user's keyboard, which
 * is how the CRM index keyboard-shortcut badges render them too.
 */
export const getCopyShortcutLabel = () => isMacOs() ? MAC_COPY_SHORTCUT : DEFAULT_COPY_SHORTCUT;